import { Text } from '@topconagriculture/react-components';
import React from 'react';
import { makeStyles } from '@material-ui/styles';
const useStyles = makeStyles(() => ({
    legend: { display: 'flex', alignItems: 'center', gap: 10, justifyContent: 'center', paddingBottom: 20 },
}));
export const DeviationChartLegend = ({ title = '' }) => {
    const classes = useStyles();
    return (React.createElement(Text, { size: 18, className: classes.legend }, title));
};
//# sourceMappingURL=DeviationChartLegend.js.map